import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'stairway-banner',
    templateUrl: './stairway.component.html',
    styleUrls: ['./stairway.component.css'],
    standalone: false
})
export class StairwayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
